import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BASE, URLS, APIS, SF_CNTY_CD_INFO } from "@/tz/go/egaz/osci/ptl/cd/cntycd/services/OsciCntyCdService";

/*
 * Country Code Modification
 * !== 지역 코드 수정 ==!
 */
export const OSCI0109011S = () => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "OSC0091" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { cntyCd } = useParams();
    const modal = useModal();
    const toast = useToast();

    const form = {
        cntyCdInfo: useForm({
            defaultSchema: SF_CNTY_CD_INFO,
        }),
    };

    const fetch = {
        getCntyCdInfo: useFetch({
            api: () => APIS.getCntyCdInfo(cntyCd),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.cntyCdInfo.content) {
                    modal.openModal({ content: "msg.osc.00050" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.osci0109009q}?menuId=${menuId}`);
                    return;
                }
                form.cntyCdInfo.setValues(data.cntyCdInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        updateCntyCdInfo: useFetch({
            api: (info: any) => APIS.updateCntyCdInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00070" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00039" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
        deleteCntyCdInfo: useFetch({
            api: (info: any) => APIS.deleteCntyCdInfo(info),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(`${URLS.osci0109009q}?menuId=${menuId}`);
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.osci0109009q}?menuId=${menuId}`),
        onUpdateBtnClick: form.cntyCdInfo.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.osc.00064", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateCntyCdInfo.fetch(form.cntyCdInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.osc.00003" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteCntyCdInfo.fetch(form.cntyCdInfo.getValue("cntyCd")),
            });
        },
    };

    useEffect(() => {
        fetch.getCntyCdInfo.fetch();
        form.cntyCdInfo.setSchema("cntyCd", { edit: false });
        form.cntyCdInfo.setSchema("cntyCd", { edit: false });
        form.cntyCdInfo.setSchema("cntyTpCd", { edit: false });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.dgt3CntyCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.dgt3NumCntyCd} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyEngAbrtNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmEn} />
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyCdInfo.schema.cntyNmTz} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"edit"} onClick={handler.onUpdateBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
